export const PORTAL_VIEW = {
  LANDING: 'access',
  LOGIN: 'login',
  RESTRICTED: 'restricted',
  NO_ACCESS_404: 'hidden',
};
